import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export const DeleteCustomersDialog = ({ visible, onHide, onConfirm, count }) => {
  const footer = (
    <React.Fragment>
      <Button label="No" icon="pi pi-times" className="p-button-text" onClick={onHide} />
      <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={onConfirm} />
    </React.Fragment>
  );

  const message = count && count > 0
    ? `Are you sure you want to delete ${count} selected customer${count !== 1 ? 's' : ''}? This cannot be undone.`
    : 'Are you sure you want to delete the selected customers? This cannot be undone.';

  return (
    <Dialog 
      visible={visible} 
      className="w-full md:w-25rem"
      header="Confirm" 
      modal 
      footer={footer} 
      onHide={onHide}
    >
      <div className="flex align-items-center p-4">
        <i className="pi pi-exclamation-triangle text-5xl text-orange-500 mr-3 align-middle" />
        <span className="text-lg">{message}</span>
      </div>
    </Dialog>
  );
};
